<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="goBack"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 申请信息 -->
    <el-descriptions border  title="申请信息" label-width="100px">
      <el-descriptions-item label="申请人" >{{
        query.applyName
      }}</el-descriptions-item>
      <el-descriptions-item label="水卡编号">{{
        query.waterCard
      }}</el-descriptions-item>
      <el-descriptions-item label="水卡类型">{{
        query.cardType == 1
          ? "电子卡"
          : query.cardType == 2
          ? "实物卡"
          : query.cardType == 3
          ? "时效电子卡"
          : query.cardType == 4
          ? "时效实物卡"
          : "- -"
      }}</el-descriptions-item>
      <!-- <el-descriptions-item label="是否绑定">
        {{ query.userId ? "已绑定" : "未绑定" }}
      </el-descriptions-item> -->
      <el-descriptions-item label="用户电话">{{
        query.phone ? query.phone : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="申请备注">{{
        query.applyMsg
      }}</el-descriptions-item>
      <el-descriptions-item label="申请图片">
        <div v-if="query.applyImgList.length > 0">
          <el-image
            v-for="(url, index) in query.imglist"
            :key="index"
            class="mgr-10"
            style="width: 100px; height: 100px"
            :src="url.url"
            :preview-src-list="query.imglist.map(item => item.url)"
          >
          </el-image>
        </div>
        <span v-else>- -</span>
      </el-descriptions-item>
      <el-descriptions-item label="归属企业">{{
        query.companyName
      }}</el-descriptions-item>
      <el-descriptions-item label="所属分区">{{
        query.regionName
      }}</el-descriptions-item>
      <el-descriptions-item label="申请时间">{{
        query.applyTime ? query.applyTime : "- -" 
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 初审信息 -->
    <el-descriptions border  title="初审信息" label-width="100px">
      <el-descriptions-item label="初审状态" label-width="100px">{{
        query.state == 1 ? "待审核" : query.state == 5 ? "已驳回" : "已通过"
      }}</el-descriptions-item>
      <el-descriptions-item label="审核人">{{
        query.checkFirstName ? query.checkFirstName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="初审时间">{{
        query.checkFirstTime ? query.checkFirstTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="初审备注">{{
        query.checkFirstMsg ? query.checkFirstMsg : "- -"
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 复审信息 -->
    <el-descriptions
      border
      title="复审信息"
      label-width="100px"
      v-if="query.checkFirstTime && query.state !== 5"  
    >
      <el-descriptions-item label="复审状态">
        {{
          query.state == 5
            ? "- -"
            : query.state == 3
            ? "已通过"
            : query.state == 4
            ? "已通过"
            : query.state == 7
            ? "已通过"
            : query.state == 6
            ? "已驳回"
            : "待审核"
        }}</el-descriptions-item
      >
      <el-descriptions-item label="审核人">{{
        query.reexamineName ? query.reexamineName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="复审时间">{{
        query.reexamineTime ? query.reexamineTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="复审备注">{{
        query.reexamineMsg ? query.reexamineMsg : "- -"
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 终审信息 -->
    <el-descriptions
      border
      column="2"
      title="终审信息"
      v-if="query.reexamineTime && query.state !== 6"
    >
      <el-descriptions-item label="终审状态">
        {{
          query.state == 5  
            ? "- -"
            : query.state == 6
            ? "- -"
            : query.state == 7
            ? "已驳回"
            : query.state == 4
            ? "已通过"
            : "待审核"
        }}
      </el-descriptions-item>
      <el-descriptions-item label="审核人">{{
        query.checkFinalName ? query.checkFinalName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="终审时间">{{
        query.checkFinalTime ? query.checkFinalTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="终审备注">{{
        query.checkFinalMsg ? query.checkFinalMsg : "- -"
      }}</el-descriptions-item>
    </el-descriptions>


    <!-- 清零信息 -->
    <!-- <el-descriptions
      border
      column="3"
      title="清零信息"
      v-if="detail.state == 4"
    >
      <el-descriptions-item label="水卡清零（扣减余额）订单编号">{{
        detail.orderNo
      }}</el-descriptions-item>
      <el-descriptions-item label="清零总金额（赠送/实付）">{{
        detail.resetPrice +
          "（" +
          detail.givePrice +
          "/" +
          detail.payPrice +
          "）"
      }}</el-descriptions-item>
      <el-descriptions-item label="清零时间">{{
        detail.resetTime
      }}</el-descriptions-item>
    </el-descriptions> -->
    <!-- 电子审批凭证 -->
    <!-- <el-descriptions
      border
      column="1"
      title="电子审批凭证"
      v-if="detail.state == 4"
    >
      <el-descriptions-item label="操作">
        <el-button type="primary" @click="handleCheckProof">查看凭证</el-button>
      </el-descriptions-item>
    </el-descriptions> -->
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      id: null,
      type: null,
      detail: null,
      query: {
        imglist:[]
      },
    };
  },
  created() {
    
    this.query = this.$route.query.query
    this.type = this.$route.query.type
    console.log('页面接收',this.query)
    // if()
    if(this.$route.query.query.applyImgList[0]){
      this.query.imglist =  JSON.parse(this.$route.query.query.applyImgList[0])
    }
    
    // this.getDetail();
  },
  methods: {
    // 详情
    getDetail() {
      this.$api.waterCard
        .cardClearZeroDetail({ id: Number(this.id) })
        .then((res) => {
          if (res.code == 200) {
            this.detail = res.data;
          }
        });
    },
    handleCheckProof() {
      this.$router.push({
        path: "/cardClearZero/detail/checkProof",
        query: {
          id: this.id,
          type: this.type,
          data: this.detail,
        },
      });
    },
    goBack() {
      console.log('返回')
      this.$router.push(
        `${
          this.type == 0
            ? "/cardClearZero/applyForRecord?type=2"
            : this.type == 1
            ? "/cardClearZero/sellFirst"
            : this.type == 2
            ? "/cardClearZero/financeAgain"
            : this.type == 3
            ? "/cardClearZero/financeEnd"
            : ""
        }`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-descriptions__title {
  color: var(--accent) !important;
  margin-top: 10px;
}
</style>
